import { render, staticRenderFns } from "./FollowersSection.vue?vue&type=template&id=2ccf2d90&scoped=true&"
import script from "./FollowersSection.vue?vue&type=script&lang=js&"
export * from "./FollowersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf2d90",
  null
  
)

export default component.exports